export default __webpack_public_path__ + "static/media/heart-empty.08a37467.svg";